import axiosClient from './axiosClient';

export const getLessonCategories = (params?: any) => {
    return axiosClient.get('/lesson-categories', { params });
};

export const getLessonCategory = (id: string) => {
    return axiosClient.get(`/lesson-categories/${id}`);
};

export const createLessonCategory = (data: any) => {
    return axiosClient.post('/lesson-categories', data);
};

export const updateLessonCategory = (id: string, data: any) => {
    return axiosClient.put(`/lesson-categories/${id}`, data);
};

export const deleteLessonCategory = (id: string) => {
    return axiosClient.delete(`/lesson-categories/${id}`);
};

export const uploadCategoryBanner = (id: string, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return axiosClient.post(`/lesson-categories/${id}/banner`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
